import { Form, FormItemProps, InputNumber } from 'antd';
import { InputNumberProps } from 'antd/lib';

import { formatterNumber, parserNumber } from '../utils';

interface InputCurrencyFormProps {
  formProps?: FormItemProps;
  inputCurrencyProps?: InputNumberProps;
}

export const InputCurrencyForm = ({
  formProps,
  inputCurrencyProps,
}: InputCurrencyFormProps) => (
  <Form.Item 
    {...formProps}
    hasFeedback={formProps?.hasFeedback !== undefined ? formProps.hasFeedback : true}
  >
    <InputNumber
      className='w-100'
      {...inputCurrencyProps}
      placeholder={inputCurrencyProps?.placeholder ?? ''}
      controls={inputCurrencyProps?.controls ?? false}
      formatter={inputCurrencyProps?.formatter ?? formatterNumber}
      parser={inputCurrencyProps?.parser ?? parserNumber}
      prefix={inputCurrencyProps?.prefix ?? '$'}
      precision={2}
    />
  </Form.Item>
);
